import { GridFilterType, TableColumnType } from 'src/types/table';

export const SHIPPING_BACKEND_KEY = 'SHIPPING_BACKEND';

/** Employee-only column; the backend rejects/strips it for everybody without EGON.VIEW. */
export const shippingBackendColumn: TableColumnType = {
    key: SHIPPING_BACKEND_KEY,
    label: 'shippingBackend',
    type: 'select',
    selectOption: 'shippingBackendCodes',
    defaultShow: false,
};

/** Employees (SKLADON_USER) with EGON.VIEW only. */
export const canViewEgon = (skladonUser: number | undefined | null, hasEgonViewPermission: boolean): boolean =>
    !!skladonUser && hasEgonViewPermission;

export const getOrderGridColumns = (baseColumns: TableColumnType[], canSeeEgon: boolean): TableColumnType[] => {
    const withoutEgon = baseColumns.filter((column) => column.key !== SHIPPING_BACKEND_KEY);
    return canSeeEgon ? [...withoutEgon, shippingBackendColumn] : withoutEgon;
};

/** Removes the EGON column/filters that could be restored from session storage for non-eligible users. */
export const sanitizeEgonGridOptions = <T extends { columns: Array<{ key: string }>; filters?: GridFilterType[] }>(
    options: T,
    canSeeEgon: boolean
): T => {
    if (canSeeEgon) {
        return options;
    }
    return {
        ...options,
        columns: options.columns.filter((column) => column.key !== SHIPPING_BACKEND_KEY),
        filters: options.filters?.filter((filter) => filter.column !== SHIPPING_BACKEND_KEY),
    };
};
